<div *ngIf="isShowModal">
  <app-backdrop (click)="close()"></app-backdrop>
  <app-modal>
    <div class="confirm_modal_title brand_color_bg">
      {{ title }}
    </div>
    <div class="confirm_modal_content">
      <ng-content></ng-content>
    </div>
    <div
      *ngIf="!hideButtons"
      mat-dialog-actions
      class="p-3 justify-content-start">
      <button
        type="button"
        mat-raised-button
        class="mr-2 theme-dark-mat-cancel-btn"
        (click)="close()">
        Отмена
      </button>
      <button
        mat-raised-button
        [class.is-active]="valid"
        [disabled]="valid"
        class="bg-dark-hover theme-dark-mat-btn is-active mr-2"
        (click)="submit()">
        Подтвердить
      </button>
    </div>
  </app-modal>
</div>
